import { render, staticRenderFns } from "./ZoneHistoryTable.vue?vue&type=template&id=b2e3b782"
import script from "./ZoneHistoryTable.vue?vue&type=script&lang=js"
export * from "./ZoneHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports